import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot } from "@angular/router";
import { ClientService } from "./client.service";

@Injectable()
export class RegionResolve implements Resolve<any> {
    constructor(public clientService: ClientService) {}

    resolve(route: ActivatedRouteSnapshot) {
        return this.clientService.resolveRegion();
    }
}
